import { useNavigate } from "react-router-dom";
import { LANGUAGES } from "../data/languages";
import { useStore } from "../store/useStore";
import { Postcard } from "../components/Postcard";
import { CardOnlyBanner } from "../components/CardOnlyBanner";
import { BRAND_TAG_CITY } from "../lib/brand";

const ROTATIONS = [-3, 2, -2, 3, -2.5, 1.5, -1, 3, -3, 2, -2, 1];

export default function LanguagePicker() {
  const navigate = useNavigate();
  const setLanguage = useStore((s) => s.setLanguage);

  return (
    <div className="grain min-h-screen w-full bg-paper px-6 py-8 flex flex-col">
      {/* Predominant card-only banner — top of screen */}
      <div className="flex justify-center mb-6">
        <CardOnlyBanner variant="dark" size="lg" />
      </div>

      <header className="text-center mb-6">
        <p className="font-mono text-xs tracking-[0.4em] text-mezcal uppercase">Bar · To·Go</p>
        <h1 className="font-display font-black text-6xl mt-2 tracking-kerned leading-none">
          ¿Cómo nos entendemos?
        </h1>
        <p className="font-hand text-2xl text-cactus mt-1">— pick your language —</p>
        <div className="mt-3 flex items-center justify-center gap-3 text-ink/40">
          <span className="h-px w-16 bg-ink/20" />
          <span className="font-mono text-[10px] tracking-widest">CHOOSE ONE · ELIGE UNO</span>
          <span className="h-px w-16 bg-ink/20" />
        </div>
      </header>

      <div className="grid grid-cols-3 md:grid-cols-4 gap-x-3 gap-y-5 max-w-3xl mx-auto w-full mt-2">
        {LANGUAGES.map((l, i) => (
          <Postcard
            key={l.code}
            rotate={ROTATIONS[i % ROTATIONS.length]}
            onClick={() => { setLanguage(l.code); navigate("/kiosk/menu"); }}
            className="aspect-[5/4] animate-rise"
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            {...({ style: { animationDelay: `${i * 40}ms`, transform: undefined as any } } as any)}
          >
            <div className="h-full flex flex-col items-center justify-center p-2 gap-1">
              <div className="text-4xl leading-none">{l.flag}</div>
              <div
                className="font-display font-bold text-xl leading-tight text-center px-1"
                dir={l.rtl ? "rtl" : undefined}
              >
                {l.label}
              </div>
              <div className="font-mono text-[9px] tracking-[0.2em] uppercase text-ink/50">
                {l.english}
              </div>
              <span className="absolute bottom-1.5 right-2 font-mono text-[9px] text-ink/40">
                № {String(i + 1).padStart(2, "0")}
              </span>
            </div>
          </Postcard>
        ))}
      </div>

      <footer className="mt-auto pt-6 text-center">
        <button onClick={() => navigate("/kiosk/join")} className="text-sm text-mezcal underline">¿Ya tienes una mesa? Únete →</button>
        <div className="font-mono text-[10px] tracking-widest text-ink/40 mt-3">{BRAND_TAG_CITY}</div>
      </footer>
    </div>
  );
}
